import BaseValidator from 'ember-cp-validations/validators/base';

const HasExternalValue = BaseValidator.extend({
  validate(value, options) {
    return value.then((product) => {
      let externalValues = product.get('externalValues');

      return externalValues.then((externalValues) => {
        let value = externalValues.find((externalValue) => {
          return externalValue[options.findByKey] === options.findByValue;
        });

        if (value) {
          return true;
        }

        return this.createErrorMessage('hasExternalValue', value, options);
      });
    });
  },
});

export default HasExternalValue;
